/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';


import CustomChart from '../../../components/CustomChart/CustomChart'
import { wordcloud } from '../../../chart';
import { CustomizedForm } from '../components/baseForm'
import baseFiled from '../components/baseFiled';

import './wordcloud'
// @ts-ignore
import logo from './logo.png'
import WordCloudPane from '../components/WordCloudPane';



const checkPx = (str) => {
  let _str = str + '';
  if (_str.indexOf('%')) {
    return _str;
  } else {
    return _str + 'px'
  }
}


const createImg = (function () {
  if (global.Image) {
    const img = new Image()
    return (url, fn) => {
      img.onload = fn
      img.src = url
    }
  }
})();

class WordCloud extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      fields: {
        ...baseFiled
      },
      list: [],
      chartWidth: '100%',
      chartHeight: '100%',
      chart: wordcloud(),
      img: null,
      fileImg: null,
      useImg: '0',
      shape: '',
      fontSpace: 20,
      color: '#000',
      customColor: '0'
    }
  }

  componentDidMount() {
    const d = [['透明烟弹',	0],['通用烟弹',	21],['便宜',	1],['检测',	0],['别买',	0],['金护盾行动',	21],['假货',	21],['官方',	39],['消费预警',	0],['打假团队',	0],['雕刻',	21],['微商',	14],['超标',	0],['苯系物',	0],['劣质烟油',	0],['德国红点',	112],['顶级',	27],['顺滑如一',	43],['防漏油',	23],['知识产权',	117],['创新',	184],['Super Smooth',  0],['自主研发',	73],['使用体验',	88],['悦刻',	971],['产品',	612],['电子',	546],['烟草',	231],['设计',	230],['用户',	222],['使用',	184],['全球',	180],['专利',	175],['申请',	154],['红点',	136],['国际',	135],['大奖',	123],['市场',	122],['品牌',	116],['温度',	113],['研发',	113],['今年',	112],['目前',	110],['公司',	108],['美国',	107],['新品',	106],['体验',	104],['主要',	97],['奖项',	96],['品质',	96],['国家',	93],['性能',	92],['体系',	88],['英国',	87],['获得',	85],['减少',	81],['3月',	81],['新型',	78],['认可',	76],['标准',	75],['德国',	75],['作品',	73],['指标',	72],['行业',	72],['获奖',	72],['同时',	71],['提升',	70],['吸烟',	69],['充电',	69],['雾化',	68],['成立',	68],['创新力',	67],['行为',	67]]
      .map(item => ({
        name: item[0],
        value: item[1]
      }))

    createImg(logo, (e)=> {
      this.setState({
        list: d,
        img: e.target
      }, this.init)
    })
  }



  init = () => {
    const {fields, list, fontSpace, customColor, color} = this.state;
    const chart = wordcloud({
      ...fields,
      list,
      fontSpace,
      color: customColor === '1' ? color : null
    });

    this.setState({
      chartHeight: checkPx(fields.chartHeight.value),
      chartWidth: checkPx(fields.chartWidth.value),
      chart: chart
    })
  }

  handleFormChange = (props, changedFields) => {
    this.setState(({ fields }) => ({
      fields: {
        ...fields,
        ...changedFields
      }
    }));
  }

  childChange = (fields) => {
    if (fields.fileImg) {
      createImg(URL.createObjectURL(fields.fileImg), (e) => {
        this.setState({
          ...fields,
          img: e.target
        })

      })
    }
    
    this.setState({
      ...fields
    })
  }

  render() {
    const {fields, chartWidth, chartHeight, chart, img, fileImg, useImg, shape, list, fontSpace} = this.state;
    if (useImg === '0') {
      chart.series[0].shape = shape
      chart.series[0].maskImage = void 0
    } else {
      chart.series[0].maskImage = img
    }
    
    return (
      <CustomChart width={chartWidth} height={chartHeight} chart={chart} callback={this.init}>
        <WordCloudPane 
          onChange={this.childChange} 
          fileImg={fileImg} 
          useImg={useImg} 
          shape={shape} 
          list={list}
          fontSpace={fontSpace}
        />
        <CustomizedForm {...fields} onChange={this.handleFormChange} />
      </CustomChart>
    )
  }
}

export default WordCloud;



// WEBPACK FOOTER //
// src/routes/customChart/WordCloud/index.js